module.exports = __webpack_public_path__ + "static/img/security.1c9900c4.png";